export default __webpack_public_path__ + "static/media/poy-1024x683.f82e4b25.jpg";